(function () {
  document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
    var grid = section.querySelector('[data-recommendations-grid]');
    var productId = section.getAttribute('data-product-id');
    var sectionId = section.getAttribute('data-section-id');
    var limit = section.getAttribute('data-limit') || 6;
    if (!grid || !productId || grid.children.length) return;
    var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit);
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations-grid]');
        if (fresh && fresh.children.length) grid.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
})();
